import { HttpParams } from '@angular/common/http';
import { toHTTPParam } from '../../../core';

import { Filter } from '../../../models';

export class FeriadoFilter implements Filter {
    isFilterDirty: boolean;

    tipos: number[] = [];
    dataInicial: Date;
    dataFinal: Date;
    ano: number;
    nome: string;

    constructor(setAnoAtual = true) {
        // Setando ano atual
        if (!this.ano && setAnoAtual) {
            this.setAnoAtual();
        }
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Tipos
        this.tipos?.forEach(tipo => {
            params = params.append('tipo', tipo.toString());
        })

        // Data Inicial
        if (this.dataInicial) {
            params = params.append('dataInicial', toHTTPParam(this.dataInicial));
        }

        // Data Final
        if (this.dataFinal) {
            params = params.append('dataFinal', toHTTPParam(this.dataFinal));
        }

        // Ano
        if (this.ano) {
            params = params.append('ano', this.ano.toString());
        }

        // Nome
        if (this.nome) {
            params = params.append('nome', this.nome);
        }

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.tipos = [];
        this.dataInicial = null;
        this.dataFinal = null;
        this.ano = null;
        this.nome = null;
    }

    setAnoAtual() {
        this.ano = new Date().getFullYear();
    }
}
